import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerWordLadderTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  WordLadderDefinition,
  WordLadderProgress,
  WordLadderSolution,
  WordLadderSubmission,
} from "./types";

registerWordLadderTranslations(i18n);

export const wordLadderModule: PuzzleTypeModule<
  WordLadderDefinition,
  WordLadderSubmission,
  WordLadderProgress,
  WordLadderSolution
> = {
  key: "word_ladder",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  // Lengths, one-letter steps and the step limit, from the public words alone.
  localFeedback,
};
